import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FeaturedGrid from './components/FeaturedGrid';
import HotRanking from './components/HotRanking';
import ArticleSection from './components/ArticleSection';
import FaqSection from './components/FaqSection';

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩国漫画网',
  url: 'http://rldcigr.com/',
  description: '免费韩漫大全资源导航站，提供便捷的韩漫在线阅读入口，简化寻找优质韩漫内容的过程',
};

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩国漫画网',
  url: 'http://rldcigr.com/',
  description: '免费韩漫大全 - 韩漫在线阅读资源导航',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://rldcigr.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '韩国漫画网 - 免费韩漫大全 - 韩漫在线阅读',
  description: '通过此漫画网址可便捷访问免费韩漫大全，并直接进行韩漫在线阅读，作为您的资源导航站，简化寻找优质内容的过程。',
  url: 'http://rldcigr.com/',
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />

      <Navbar />
      <main>
        <FeaturedGrid />
        <HotRanking />
        <ArticleSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}